/**
 * dapp-kit v2's `ConnectButton`, lazily loaded.
 *
 * `@mysten/dapp-kit-react/ui` imports the scoped custom-element registry
 * polyfill, which touches `window` at module scope. Vite has no server render,
 * so that is no longer fatal — but the entry is heavy and pulls in the whole Lit
 * element set, so it stays behind `React.lazy` to keep it out of the initial
 * chunk. `Suspense` falls back to `null`, matching the old `loading: () => null`.
 *
 * The button is a Lit custom element rendering into shadow DOM: Tailwind classes
 * on it only affect the host box (size/margins). Colours and radii come from the
 * `--dapp-kit-*` custom properties set on `:root` in `src/styles/globals.css`,
 * and `::part(trigger)` is available for padding/sizing of the inner button.
 */
import { lazy, Suspense } from "react";

const LazyConnectButton = lazy(async () => {
  const { ConnectButton } = await import("@mysten/dapp-kit-react/ui");

  return { default: ConnectButton };
});

export type ConnectWalletButtonProps = {
  className?: string;
};

export const ConnectWalletButton = ({ className }: ConnectWalletButtonProps) => (
  <Suspense fallback={null}>
    <LazyConnectButton className={className} />
  </Suspense>
);
